<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <h1>Browse Organizations</h1>
      </v-col>
    </v-row>
    <v-row>
      <OrganizationList />
    </v-row>
  </v-container>
</template>

<script>
  import OrganizationList from './OrganizationList.vue'

  export default {
    name: 'OrganizationsPage',

    components: {
      OrganizationList,
    },

    data: () => ({
      // TODO - add search feat.
      search: ''
    })
  }
</script>
